var MerchantStatus;
(function (MerchantStatus) {
    MerchantStatus[MerchantStatus["Prospect"] = 0] = "Prospect";
    MerchantStatus[MerchantStatus["Basic"] = 1] = "Basic";
    MerchantStatus[MerchantStatus["Preferred"] = 2] = "Preferred";
    MerchantStatus[MerchantStatus["VC"] = 3] = "VC";
    MerchantStatus[MerchantStatus["Linkout"] = 4] = "Linkout";
})(MerchantStatus || (MerchantStatus = {}));
const PAYMENT_METHODS_PAYPAL = 'Paypal';
const PAYMENT_METHODS_STRIPE = 'Stripe';
const IcePacksSupports = {
    NoSupport: 0,
    Free: 1,
    Paid: 2,
};
const isVCMerchant = (merchant) => (merchant === null || merchant === void 0 ? void 0 : merchant.status) === MerchantStatus.VC;
const isLinkoutMerchant = (merchant) => (merchant === null || merchant === void 0 ? void 0 : merchant.status) === MerchantStatus.Linkout;
const hasPayPal = (merchant) => {
    var _a, _b;
    return !!((_b = (_a = merchant.payment_options) === null || _a === void 0 ? void 0 : _a.methods) === null || _b === void 0 ? void 0 : _b.find((e) => e.name.toLowerCase() === PAYMENT_METHODS_PAYPAL.toLowerCase()));
};

export { IcePacksSupports, MerchantStatus, PAYMENT_METHODS_PAYPAL, PAYMENT_METHODS_STRIPE, hasPayPal, isLinkoutMerchant, isVCMerchant };
//# sourceMappingURL=merchant.js.map
